import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import BaseSelect from 'components/baseSelect';

const LanguageForm = ({errors, touched, handleChange, values, element, removeLanguageForm, empresaId = 96}) => {
    const onRemoveForm = () => removeLanguageForm(element.id);
    return (
        <>
            <BaseSelect
                md={2}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Idioma *'}
                name={`language_${element.id}`}
                url={'Idioma?$filter=empresaId eq ' + empresaId}
            />
            <BaseSelect
                md={2}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Habla *'}
                name={`speak_${element.id}`}
                url={'IdiomaNivel?$filter=empresaId eq ' + empresaId}
            />
            <BaseSelect
                md={2}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Lee *'}
                name={`read_${element.id}`}
                url={'IdiomaNivel?$filter=empresaId eq ' + empresaId}
            />
            <BaseSelect
                md={2}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Escribe *'}
                name={`write_${element.id}`}
                url={'IdiomaNivel?$filter=empresaId eq ' + empresaId}
            />
            <Form.Group className="display-flex flex-end-vertical" as={Col} md="4">
                <Button onClick={onRemoveForm} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
            </Form.Group>
        </>
    )
}

export default LanguageForm;